module.exports = __webpack_public_path__ + "media/images/work_articles_tab1_icon-e23c7eef65cd9a1fdb51bf5a9aa75d0a.png";